export const asStar = {
  data: `<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.6663 5.49268L8.87301 5.07935L6.99967 0.666016L5.12634 5.08602L0.333008 5.49268L3.97301 8.64602L2.87967 13.3327L6.99967 10.846L11.1197 13.3327L10.033 8.64602L13.6663 5.49268ZM6.99967 9.59935L4.49301 11.1127L5.15967 8.25935L2.94634 6.33935L5.86634 6.08602L6.99967 3.39935L8.13967 6.09268L11.0597 6.34602L8.84634 8.26602L9.51301 11.1193L6.99967 9.59935Z"/>
  </svg>`,
  name: 'star',
};
